import React, { CSSProperties } from 'react';
import styled from 'styled-components';

const Layout = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

interface ImagePlayerProps {
  imgSrc: string;
  style?: CSSProperties;
}

export default function ImagePlayer(props: ImagePlayerProps) {
  return (
    <Layout style={props.style}>
      <img
        src={props.imgSrc}
        style={{
          filter: 'blur(7px)',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}
      />
      <img
        style={{
          transform: 'scale3d(1,1,1)',
          maxHeight: '100%',
          maxWidth: '100%',
        }}
        src={props.imgSrc}
      />
    </Layout>
  );
}
